const projectRoleList = [
    {
        id: 0,
        title: 'Project Manager',
        value: 'Project Manager'
    },
    {
        id: 1,
        title: 'Site Superintendent',
        value: 'Site Superintendent'
    },
    {
        id: 2,
        title: 'General Contractor',
        value: 'General Contractor'
    },
    {
        id: 3,
        title: 'Architect',
        value: 'Architect'
    },
    {
        id: 4,
        title: 'Sales & Marketing',
        value: 'Sales & Marketing'
    },
    {
        id: 5,
        title: 'Property Management',
        value: 'Property Management'
    },
    {
        id: 6,
        title: 'Quantitative Surveyor',
        value: 'Quantitative Surveyor'
    },
    {
        id: 7,
        title: 'Other',
        value: 'Other'
    },
];

export const teamMembersData = {
    projectRoleList
}